import gql from 'graphql-tag';

const GET_LOGIN_CONFIRMATION_CONTENT = gql`
  query getLoginConfirmationContent($loginFlow: String!) {
    me {
      layout {
        loginConfirmationContent: vcmsAsset(
          structure: "LoginConfirmationPage"
          properties: { cmsidentifier: $loginFlow }
        )
      }
      isFacebookLoginEnabled: featureFlag(key: "ACCTID_FACEBOOK_LOGIN_ENABLED")
      recaptchaEnabled: featureFlag(key: "RECAPTCHA_ENABLED")
    }
  }
`;

export default GET_LOGIN_CONFIRMATION_CONTENT;
